import { useEffect } from 'react';

export default function JsonLd({ id, data }) {
  useEffect(() => {
    const tag = document.createElement('script');
    tag.type = 'application/ld+json';
    tag.id = `jsonld-${id}`;
    tag.text = JSON.stringify(data);
    const existing = document.getElementById(tag.id);
    if (existing) existing.remove();
    document.head.appendChild(tag);
    return () => { tag.remove(); };
  }, [id, JSON.stringify(data)]);
  return null;
}
